export const STOREFRONT_ENDPOINT = "/api/2025-10/graphql.json";
